module.exports = __webpack_public_path__ + "img/power-03.5b343987.svg";